import MultipleDocActions from './MultipleDocActions';

export default MultipleDocActions;
